'use client';
import { useEffect, useRef, useState } from 'react';
// The avatar takes its size from the text block beside it (Founder 2026-09-28): on the category card the photo must never
// reach below the "<city> והסביבה" line, on the home cards it may grow into the card's own empty padding but never grow the
// card. Measured live (ResizeObserver) so every phone, font size and text length gets its exact fit.
// v2 (bughunter A1): the text lines WRAP (never truncate), so the photo simply follows the text's REAL height, clamped to
// [min,max]. Stable: a bigger photo can only make the text taller, never shorter, and the cap ends it — no truncation, no
// oscillation. (v1 measured an unwrapped clone: a long nationwide line pinned every photo to the minimum.)
//   extra = px the avatar may exceed the text height (taken from padding the caller offsets with a negative margin)
export function useFitAvatar(fallback: number, { min = 64, max = 140, extra = 0 }: { min?: number; max?: number; extra?: number } = {}) {
  const textRef = useRef<HTMLDivElement | null>(null);
  const [size, setSize] = useState<number | null>(null);
  useEffect(() => {
    const el = textRef.current; if (!el) return;
    const fit = () => { const h = el.getBoundingClientRect().height; if (h > 0) setSize(s => { const n = Math.round(Math.max(min, Math.min(max, h + extra))); return s === n ? s : n; }); };
    fit(); const ro = new ResizeObserver(fit); ro.observe(el); return () => ro.disconnect();
  }, [min, max, extra]);
  return { textRef, size: size ?? fallback, measured: size != null };
}
